export default (rounds) => {
  return JSON.parse(JSON.stringify(rounds)).sort((a, b) => {
      if (b.state === 'Active' && a.state !== 'Active') return 1;
      return -1;
    })
    .filter((round, i, self) => {
      const existingIndex = self.findIndex((item) => item.name === round.name);
      if (existingIndex !== -1 && existingIndex !== i) {
          if (self[existingIndex].state === 'Active') {
              // another round with the same name is active, prefer that round over current
              return false;
          } else if (round.state === 'Active') {
              // another round with the same name found, but current is active, prefer current
              return true;
          } else {
              // another round with the same name found, prefer that round over current
              return false;
          }
      }
      return true;
    })
    .sort((a, b) => {
      return a.order - b.order;
    });
}


// WEBPACK FOOTER //
// ./src/utils/getUniqueRounds.js